<script lang="ts">
  import { push } from 'svelte-spa-router';

  export let items: Array<{ label: string; href?: string }> = [];

  function navigate(href: string | undefined) {
    if (href) {
      push(href);
    }
  }
</script>

<nav class="breadcrumbs" aria-label="Breadcrumb">
  <ol class="breadcrumb-list">
    {#each items as item, index}
      <li class="breadcrumb-item">
        {#if item.href && index < items.length - 1}
          <a href={item.href} on:click|preventDefault={() => navigate(item.href)} class="breadcrumb-link">{item.label}</a>
        {:else}
          <span class="breadcrumb-current">{item.label}</span>
        {/if}
        {#if index < items.length - 1}
          <span class="breadcrumb-separator" aria-hidden="true">/</span>
        {/if}
      </li>
    {/each}
  </ol>
</nav>

<style>
  .breadcrumbs {
    margin-bottom: 1.5rem;
  }

  .breadcrumb-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .breadcrumb-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .breadcrumb-link {
    color: #6b7280;
    text-decoration: none;
    font-size: 0.875rem;
    transition: color 0.2s;
  }

  .breadcrumb-link:hover {
    color: #111827;
  }

  .breadcrumb-current {
    color: #111827;
    font-size: 0.875rem;
    font-weight: 500;
  }

  .breadcrumb-separator {
    color: #9ca3af;
    font-size: 0.875rem;
    margin-left: 0.5rem;
  }
</style>

